import { render, staticRenderFns } from "./FieldEdit.vue?vue&type=template&id=7406f2da"
import script from "./FieldEdit.vue?vue&type=script&lang=ts"
export * from "./FieldEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7406f2da')) {
      api.createRecord('7406f2da', component.options)
    } else {
      api.reload('7406f2da', component.options)
    }
    module.hot.accept("./FieldEdit.vue?vue&type=template&id=7406f2da", function () {
      api.rerender('7406f2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/FieldEdit.vue"
export default component.exports